import styled from 'styled-components';
import { ThemedComponent } from '@la/ds-ui-components';

export const AddOnPropertiesDesc = styled.p<ThemedComponent>(({ theme }) => {
  const { foundational, typography } = theme;
  return {
    ...typography.ui.small,
    color: foundational.blueGrey[600],
  };
});
